// About.js
import React from 'react';
import '../styles/PacDebt.css';  // Import the CSS file
import Breadcrumbs from '../../src/components/Breadcrumbs';
import styled from 'styled-components'

const About = () => {
    return (
        <StyledAboutContainer>
            <div className="container">
                <h1 className="heading">Learn More About Us</h1>
                <Breadcrumbs />
            </div>
        </StyledAboutContainer>

    )
};

export default About;

const StyledAboutContainer = styled.div`
    .spanText {
        padding-right: 10px;
        font-size: 20px;
    }
`